import React, {useEffect, useState} from 'react';
import SmallSpinner from "../Spinners/SmallSpinner";

const APIFrame = ({src, ...otherProps}) => {
    const [objectUrl, setObjectUrl] = useState(null)
    const [error, setError] = useState(null)

    let url = new URL(src)
    url.searchParams.delete('access_token');
    url = url.toString()

    const slices = url.split('/')
    const fileName = slices[slices.length - 1]

    useEffect(() => {
        // Utilise les cookies HttpOnly pour l'authentification
        fetch(url, {credentials: 'include'})
            .then((response) => {
                if (response.ok) {
                    response.blob()
                        .then(blob => setObjectUrl(window.URL.createObjectURL(blob)))
                } else {
                    setError(`Erreur lors du téléchargement du fichier ${fileName}`)
                }
            })
    }, [src])

    if (error) {
        return <p className={'text-danger'}>{error}</p>
    }

    if (!objectUrl) {
        return <div><SmallSpinner size={12} /> T&eacute;l&eacute;chargement du fichier {fileName}...</div>
    }

    return <object data={objectUrl} {...otherProps} title={fileName} />
}

export default APIFrame;
